@if (agent) {
  <div class="welcome-message">
    <div class="welcome-message__content">
      <h2 class="welcome-message__title">Consult with <span class="bot-name">{{ agent.name }}</span></h2>
      <div class="welcome-message__actions">
        <app-custom-button [icon]="'mode_edit'" [tooltip]="'Edit'" (click)="onEdit()"></app-custom-button>
        <app-custom-button [icon]="'history'" [tooltip]="'Configuration history'" (click)="onHistory()"></app-custom-button>
        <app-custom-button [icon]="'content_paste'" [tooltip]="'Prompt hints'" (click)="onPromptHints()"></app-custom-button>
        <app-custom-button [icon]="'content_copy'" [tooltip]="'Duplicate'" (click)="onDuplicate()"></app-custom-button>
        <app-custom-button [icon]="'delete'" [tooltip]="'Delete'" (click)="onDelete()"></app-custom-button>
      </div>
    </div>
  </div>
}
